import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import uiid from 'uuid';

import {
  StyledContentGrouping,
  StyledMonthAudience,
  StyledDays,
  StyledMaskOl,
  StyledOl,
  StyledItem,
  StyledTime,
  StyledWeekDay,
  StyledDay,
  StyledChannel,
  StyledListChannel,
  StyledItemChannel,
  StyledRowGroup,
  StyledCarousel,
  StyledRow,
  StyledCell,
  StyledButtonPrev,
  StyledButtonNext,
  StyledMediaMonth
} from './style';

import { CHANNELS_ICON } from '../../../constants/channels';
import { DAYS } from '../../../constants/dates';

import Icon from '../../core/Icon';

import { Arrow, ArrowLeft } from '../../../../assets/images/index';

import { getMonth } from '../../../utils/dates';

class MonthAudience extends Component {
  constructor(props) {
    super(props);

    const formattedData = props.data.map(item => {
      const audiences = item.audiences.reduce((total, audience) => {
        const audienceCloned = { ...audience };
        audienceCloned.dayOfWeek = DAYS[audience.dayOfWeek];
        audienceCloned.day =
          audience.day < 10 ? `0${audience.day}` : `${audience.day}`;
        total.push(audienceCloned);
        return total;
      }, []);

      return { ...item, audiences };
    });

    this.state = {
      data: formattedData,
      xSlide: 0,
      activePrevButton: false,
      activeNextButton: true,
      MOVEX: 0,
      steps: 0
    };

    this.nextDays = this.nextDays.bind(this);
    this.previusDays = this.previusDays.bind(this);
    this.setSteps = this.setSteps.bind(this);
  }

  componentDidMount() {
    this.initCarousel();
  }

  setSteps(steps) {
    if (steps === 0) {
      this.setState({
        steps,
        activeNextButton: false,
        activePrevButton: false
      });
    } else {
      this.setState({
        steps
      });
    }
  }

  initCarousel() {
    const el = ReactDOM.findDOMNode(this.daysRef);
    const navigatorWidth = window.innerWidth;

    /** mobile version */
    if (navigatorWidth <= 720) {
      const steps = Math.floor(el.children.length / 5);

      this.setState(
        {
          MOVEX: 240
        },
        () => this.setSteps(steps)
      );
    }

    /** tablet version */
    if (navigatorWidth > 720 && navigatorWidth < 1280) {
      const steps = Math.floor(el.children.length / 10);

      this.setState(
        {
          MOVEX: 491
        },
        () => this.setSteps(steps)
      );
    }
  }

  /* Avanza días en el mes */
  nextDays() {
    let { xSlide } = this.state;
    const { MOVEX, steps } = this.state;

    xSlide -= MOVEX;

    if (xSlide === -(steps * MOVEX)) {
      this.setState({
        xSlide,
        activeNextButton: false,
        activePrevButton: true
      });
    } else {
      this.setState({
        xSlide,
        activePrevButton: true
      });
    }
  }

  previusDays() {
    const { MOVEX } = this.state;
    let { xSlide } = this.state;

    xSlide += MOVEX;

    if (xSlide === 0) {
      this.setState({
        xSlide,
        activePrevButton: false,
        activeNextButton: true
      });
    } else {
      this.setState({
        xSlide,
        activeNextButton: true
      });
    }
  }

  render() {
    const { formats, isMobile, columnHover, day, date } = this.props;
    const { data, xSlide, activePrevButton, activeNextButton } = this.state;

    return (
      <StyledContentGrouping
        title={`Audiencias del mes de ${getMonth(date)} hasta el dia ${day}`}
        formats={formats}
      >
        <StyledMonthAudience role="table">
          <StyledDays role="rowgroup" activePrevButton={activePrevButton}>
            <StyledButtonPrev
              transparent
              activePrevButton={activePrevButton}
              onClick={this.previusDays}
            >
              <Icon svg={ArrowLeft} size="s" />
            </StyledButtonPrev>
            <StyledMaskOl>
              <StyledOl
                role="row"
                xSlide={xSlide}
                ref={reference => {
                  this.daysRef = reference;
                }}
              >
                <StyledItem role={isMobile ? 'columnheader' : 'rowheader'}>
                  <StyledTime>
                    <StyledMediaMonth>
                      {getMonth().substring(0, 3)}
                    </StyledMediaMonth>
                  </StyledTime>
                </StyledItem>
                {data &&
                  data[0].audiences.map(data => (
                    <StyledItem
                      key={data.day}
                      role={isMobile ? 'columnheader' : 'rowheader'}
                    >
                      <StyledTime>
                        <StyledWeekDay>{data.dayOfWeek}</StyledWeekDay>
                        <StyledDay>{data.day}</StyledDay>
                      </StyledTime>
                    </StyledItem>
                  ))}
              </StyledOl>
            </StyledMaskOl>

            <StyledButtonNext
              transparent
              activeNextButton={activeNextButton}
              onClick={this.nextDays}
            >
              <Icon svg={Arrow} transparent size="s" />
            </StyledButtonNext>
          </StyledDays>
          <StyledChannel role="rowgroup">
            <StyledListChannel role="row">
              {data &&
                data.map(channel => (
                  <StyledItemChannel
                    key={channel.name}
                    role={isMobile ? 'rowheader' : 'columnheader'}
                    columnHover={columnHover}
                  >
                    <Icon
                      svg={CHANNELS_ICON[channel.name].icon}
                      width="25px"
                      height="25px"
                    />
                  </StyledItemChannel>
                ))}
            </StyledListChannel>
          </StyledChannel>
          <StyledCarousel>
            <StyledRowGroup role="rowgroup" xSlide={xSlide}>
              {data &&
                data.map(channel => (
                  <StyledRow
                    key={channel.name}
                    role="row"
                    columnHover={columnHover}
                  >
                    {channel.audiences &&
                      channel.audiences.map((data, index) =>
                        !index ? (
                          <React.Fragment key={`${uiid.v4()}`}>
                            <StyledCell role="cell">
                              <strong>{channel.averageAudience}</strong>
                            </StyledCell>
                            <StyledCell role="cell">{data.value}</StyledCell>
                          </React.Fragment>
                        ) : (
                          <StyledCell key={`${uiid.v4()}`} role="cell">
                            {data.value}
                          </StyledCell>
                        )
                      )}
                  </StyledRow>
                ))}
            </StyledRowGroup>
          </StyledCarousel>
        </StyledMonthAudience>
      </StyledContentGrouping>
    );
  }
}

MonthAudience.propTypes = {
  formats: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      href: PropTypes.string
    })
  ),

  /** Datos de las audiencias medias de cada canal (canal, fecha y dato de audiencia) */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      audiences: PropTypes.arrayOf(
        PropTypes.shape({
          day: PropTypes.number,
          dayOfWeek: PropTypes.string,
          value: PropTypes.number
        })
      )
    })
  ).isRequired,

  /** true: Estamos en un dispositivo móvil */
  isMobile: PropTypes.bool,

  /** Al hacer hover en una de las columnas se pone a true esta propiedad */
  columnHover: PropTypes.bool,
  day: PropTypes.string.isRequired
};

MonthAudience.defaultProps = {
  isMobile: false,
  columnHover: false
};

export default MonthAudience;
